import React from "react";

export default function UpgradeBadge(props) {
  if (props.isPro) {
    return <span className="pro-badge">PRO</span>;
  }
  return (
    <span className="upgrade-badge">
      <span role="img" aria-label="emoji">
        ⚡
      </span>
      <span className="upgrade-text">UPGRADE</span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/UpgradeBadge/index.js